import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto" })
], -1)
const _hoisted_2 = { id: "management" }
const _hoisted_3 = { class: "bg-white py-8 lg:py-10 rounded-md shadow-sm mx-auto max-w-7xl" }
const _hoisted_4 = {
  key: 1,
  class: "mx-auto grid grid-cols-1 gap-14 px-8 xl:gap-y-20 xl:px-10 xl:grid-cols-3 items-start"
}
const _hoisted_5 = { class: "mx-auto xl:max-w-2xl xl:mx-0 xl:sticky top-5" }
const _hoisted_6 = { class: "md:flex md:flex-row-reverse md:items-start xl:block" }
const _hoisted_7 = { class: "xl:col-span-2 space-y-8" }
const _hoisted_8 = { class: "xl:pr-8" }
const _hoisted_9 = { class: "mb-6 text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl flex items-center gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Why Gelt?", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-outside" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("We deliver quick loan approvals and fast processing, closing in as little as "),
      /*#__PURE__*/_createElementVNode("b", null, "7 days"),
      /*#__PURE__*/_createTextVNode(".")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("We provide an end-to-end tailored loan process with "),
      /*#__PURE__*/_createElementVNode("b", null, "no appraisals required"),
      /*#__PURE__*/_createTextVNode(", complemented by our flexible approach and extended client availability.")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_OriginatorName = _resolveComponent("OriginatorName")!
  const _component_OriginatorBio = _resolveComponent("OriginatorBio")!
  const _component_OriginatorCtaWithOptions = _resolveComponent("OriginatorCtaWithOptions")!
  const _component_OriginatorLenderCta = _resolveComponent("OriginatorLenderCta")!
  const _component_LightBulbIcon = _resolveComponent("LightBulbIcon")!
  const _component_OriginatorPreferences = _resolveComponent("OriginatorPreferences")!
  const _component_OriginatorActivity = _resolveComponent("OriginatorActivity")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.originator)
          ? (_openBlock(), _createBlock(_component_BaseSpinner, {
              key: 0,
              class: "h-80"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_OriginatorName, {
                  class: "mb-6",
                  originator: _ctx.originator,
                  lender: _ctx.lender
                }, null, 8, ["originator", "lender"]),
                _createVNode(_component_OriginatorBio),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_OriginatorCtaWithOptions, {
                    class: "mt-10 md:w-1/2 xl:w-full md:pl-4 xl:pl-0",
                    originator: _ctx.originator
                  }, null, 8, ["originator"]),
                  _createVNode(_component_OriginatorLenderCta, { class: "mt-10 md:w-1/2 xl:w-full md:pr-4 xl:pr-0" })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h3", _hoisted_9, [
                    _createVNode(_component_LightBulbIcon, { class: "inline-block h-9 w-9" }),
                    _hoisted_10
                  ]),
                  _hoisted_11
                ]),
                _createVNode(_component_OriginatorPreferences, { originator: _ctx.originator }, null, 8, ["originator"]),
                _createVNode(_component_OriginatorActivity)
              ])
            ]))
      ])
    ])
  ], 64))
}